import { Deserializable } from './deserializable.model';
import { UserRewardItem } from './user-reward-item.model';

export class UserRewards implements Deserializable<UserRewards> {
  public total = 0;
  public count = 0;
  public is_referred = false;
  public referral_code = '';
  public list: UserRewardItem[] = [];
  public from_sync: UserRewardItem[] = [];
  public last_reward_date = 0;
  public last_reward_amt = 0;

  constructor(params?: { [k: string]: any }) {
    if (params) {
      return this.deserialize(params);
    }
  }

  public deserialize(params: any): UserRewards {
    for (const [key, val] of Object.entries(params)) {
      if (key in this) {
        this[key] = val;
      }
    }
    return this;
  }
}
